import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "order-2" }

import { ref } from "vue";
import { Analytics } from "~/js/interfaces/Analytics";
import { getClasses } from "~/js/composables/classes";
import { getIcon } from "~/js/composables/icons";

interface Props {
	ga?: Analytics | null;
	content?: string;
	size?: "small" | "default";
	icon?: string;
	iconPosition?: "before" | "after";
	type?: "button" | "div";
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonQuarternary',
  props: {
    ga: { default: null },
    content: { default: "" },
    size: { default: "default" },
    icon: { default: null },
    iconPosition: { default: "before" },
    type: { default: "button" }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	default: "inline-flex justify-center items-center rounded-full whitespace-nowrap",
	position: props.iconPosition == "after" ? "flex-row-reverse" : "flex-row",
	animation: "transition-colors duration-200 ease-in-out",
	color: "text-black",
	focus: "focus:ring-4 focus:ring-celestial-500 focus:outline-none",
	font: "font-primary leading-8 font-medium tracking-wider",
	hover: "hover:bg-viridian-200",
	disabled: "disabled:text-concrete-700",
	padding: props.size == "default" ? "px-6 py-4" : "px-4 py-1",
	text: props.size == "default" ? "text-lg-" : "text-base",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.type), {
    class: _normalizeClass(_unref(getClasses)(classes.value)),
    "data-tag-category": __props.type == 'button' ? (__props.ga?.category ?? '') : false,
    "data-tag-action": __props.type == 'button' ? (__props.ga?.action ?? '') : false,
    "data-tag-label": __props.type == 'button' ? (__props.ga?.label ?? '') : false
  }, {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(__props.content), 1),
      (__props.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass([_unref(getIcon)(__props.icon), __props.iconPosition == 'after' ? 'ml-2' : 'mr-2'])
          }, null, 2))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["class", "data-tag-category", "data-tag-action", "data-tag-label"]))
}
}

})